module.exports = {
    api: {
         API_URL: process.env.REACT_APP_API_URL || "http://localhost:3001" || "http://spaculus.live:3001" || "http://52.205.213.144:3001/" || "https://myoutdoorshare.com" || "http://44.194.173.28" || "http://staging.myoutdoorshare.com/" || "https://44.194.173.28" || "https://staging.myoutdoorshare.com/",
        //API_URL: "https://staging.myoutdoorshare.com",
        CHAT_SERVICE_URL: "https://i80rsjcw2f.execute-api.us-east-1.amazonaws.com"
    },
    otp_timeout: 1000,// in seconds
    otp_timeout_minute: (5 * 1000),// in minutes
};
